import { useRedirectStore } from '../stores/redirectStore';

export const useMenuHooks = () => {
  return {
    callBack,
    isChecked
  };
};

const callBack = (redirectModule: string) => {
  const redirects = useRedirectStore.getState();

  switch (redirectModule) {
    case 'redação':
      redirects.setEssay_my_essays(!redirects.essay_my_essays);
      break;
    case 'meu desempenho':
      redirects.setEssay_performance(!redirects.essay_performance);
      break;
    case 'temas':
      redirects.setEssay_theme(!redirects.essay_theme);
      break;
    case 'simulador':
      redirects.setSimulation(!redirects.simulation);
      break;
    case 'simuladão ENEM':
      redirects.setSimulation_enem(!redirects.simulation_enem);
      break;
    case 'monitorias':
      redirects.setLive_monitoring(!redirects.live_monitoring);
      break;
    case 'lives':
      redirects.setLive(!redirects.live);
      break;
    case 'Desafio 60 dias':
      redirects.setLive_challenge(!redirects.live_challenge);
      break;
    case 'perfil':
      redirects.setProfile(!redirects.profile);
      break;
    case 'favoritos':
      redirects.setMy_favorites(!redirects.my_favorites);
      break;
    case 'Meus planos':
      redirects.setMy_plans(!redirects.my_plans);
      break;
    case 'mural':
      redirects.setMural(!redirects.mural);
      break;
    default:
      break;
  }
};

const isChecked = (redirectModule: string) => {
  const redirects = useRedirectStore.getState();

  switch (redirectModule) {
    case 'redação':
      return redirects.essay_my_essays;
    case 'meu desempenho':
      return redirects.essay_performance;
    case 'temas':
      return redirects.essay_theme;
    case 'simulador':
      return redirects.simulation;
    case 'simuladão ENEM':
      return redirects.simulation_enem;
    case 'monitorias':
      return redirects.live_monitoring;
    case 'lives':
      return redirects.live;
    case 'Desafio 60 dias':
      return redirects.live_challenge;
    case 'perfil':
      return redirects.profile;
    case 'favoritos':
      return redirects.my_favorites;
    case 'Meus planos':
      return redirects.my_plans;
    case 'mural':
      return redirects.mural;
    default:
      return false;
  }
};
